<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col head">
                            <h3 class="mb-0">
                              Dentistas Externos
                            </h3>

                            <base-button :to="'/dentistas-externos/f'" type="default" icon="fas fa-plus" size="md" title="Adicionar Item"></base-button>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">

                          <base-input class="mr-2 flex-grow-1" type="text" placeholder="nome" v-model="filtros.nome"></base-input>

                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="dentistaList">
                            <template slot="columns">
                              <th>ID</th>
                              <th>Nome Completo</th>
                              <th class="text-center">CPF</th>
                              <th class="text-center">E-mail</th>
                              <th class="text-center">Contato</th>
                              <th class="text-center">Data de Cadastro</th>
                              <th></th>
                            </template>

                            <template slot-scope="{row}">
                              <th scope="row">
                                <span>{{ row.id }}</span>
                              </th>
                              <td>
                                {{ row.nome }}
                              </td>
                              <td class="text-center">
                                {{ row.cpf }}
                              </td>
                              <td class="text-center">
                                {{ row.email }}
                              </td>
                              <td class="text-center">
                                {{ row.celular }} {{ row.telefone ? ' / ' + row.telefone : '' }}
                              </td>
                              <td class="text-center">
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>
                              <td class="text-center">
                                  <base-button :to="'/ordens/solicitar/'+row.id" type="default" icon="ni ni-bullet-list-67" size="sm" title="Criar Ordem de Serviço"></base-button>
                                  <base-button :to="'/dentistas-externos/f/'+row.id" type="default" icon="far fa-eye" size="sm" title="Visualizar item"></base-button>
                              </td>

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import dentista from '@/cflow/dentistaexterno.js'
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  export default {
    name: 'tables',
    components: {
      BaseButton,
      BaseInput
    },
    methods: {
      setStatus: function(row, flag) {
        let status = {
          label: null,
          value: null
        }

        if(row.quant > row.min_quant) {
          status.label = 'Disponível';
          status.color = 'success';
        }

        if(row.quant <= row.min_quant) {
          status.label = 'Reposição';
          status.color = 'warning';
        }

        if(row.quant == 0) {
          status.label = 'Sem Estoque';
          status.color = 'danger';
        }

        return status[flag];

      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;

          dentista.listar({filtros: this.filtros}, 0).then(res => {
            this.dentistaList = res;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(() => {
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        this.skiped += this.dentistaList.length;
        this.initLoad(this.skiped);
      },
      initLoad: function(skiped) {
        this.loading = true;

        Promise.all([dentista.listar([], skiped)]).then( res => {
          this.dentistaList = this.dentistaList.concat(res[0]);
          this.loading = false;
        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        loading: false,
        skiped: 0,
        dentistaList:[],
        idxList:[],
        status: [{'nome': 'Laboratórios', 'valor': 'lab'}, {'nome': 'Dentistas', 'valor': 'den'}],
        coresStatus: ['warning','info','primary','info','info','success','danger','danger'],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        filtros: {
            status: null,
            none: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        }
      }
    },
    mounted(){
      this.initLoad(0, 0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
.head {
  display: flex;
  justify-content: space-between;
}
</style>
